import paginatedStore from '../lib/paginatedStore'
export default paginatedStore('/campaigns/active/gallery', err =>
	err.name === 'APIError' && err.status === 403
		? 'Sorry, no gallery is currently available for this campaign.'
		: 'Failed to fetch the gallery.'
)
